/**
 * @see https://github.com/angular/angular/blob/de25cdac54a484cd03d5931f75a08ff56f27f779/packages/forms/src/validators.ts#L465
 */
const EMAIL_REGEXP =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function emailIsValid(email: string) {
  return EMAIL_REGEXP.test(email);
}
